import React from 'react';
import { useAppSelector } from 'store/hooks';
import { selectHasSetupFraudDetection } from 'features/quests/store/selectors';
import BreachesDetectedCard from './BreachesDetectedCard';
import FraudDetectionSetupCard from './FraudDetectionSetupCard';
const FreeTierFraudDetectionCard = () => {
    const hasSetupFraudDetection = useAppSelector(selectHasSetupFraudDetection);
    return hasSetupFraudDetection ? (<BreachesDetectedCard />) : (<FraudDetectionSetupCard />);
};
export default FreeTierFraudDetectionCard;
